import React from 'react';
import { Link } from 'react-router-dom';
import { CalendarIcon, BuildingIcon } from 'lucide-react';
import { mockProperties } from '../../data/mockData';
const ProjectCard = ({
  project
}) => {
  // Find the property this project belongs to
  const property = mockProperties.find(p => p.id === project.propertyId);
  // Calculate progress percentage
  const progressPercentage = Math.round(project.completedTasks / project.totalTasks * 100);
  // Define status color based on project status
  const getStatusColor = status => {
    switch (status) {
      case 'Planning':
        return 'bg-blue-100 text-blue-800';
      case 'In Progress':
        return 'bg-green-100 text-green-800';
      case 'At Risk':
        return 'bg-yellow-100 text-yellow-800';
      case 'On Hold':
        return 'bg-gray-100 text-gray-800';
      case 'Completed':
        return 'bg-purple-100 text-purple-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };
  return <Link to={`/projects/${project.id}`} className="block" data-id="element-30">
      <div className="bg-white border border-gray-200 rounded-lg shadow-sm overflow-hidden hover:shadow-md transition-shadow" data-id="element-31">
        <div className="p-4" data-id="element-32">
          <div className="flex justify-between items-start mb-2" data-id="element-33">
            <h3 className="text-lg font-medium text-gray-900" data-id="element-34">
              {project.name}
            </h3>
            <span className={`px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusColor(project.status)}`} data-id="element-35">
              {project.status}
            </span>
          </div>
          {property && <div className="flex items-center text-gray-500 text-sm mb-3" data-id="element-36">
              <BuildingIcon className="w-4 h-4 mr-1 flex-shrink-0" data-id="element-37" />
              <span className="truncate" data-id="element-38">{property.name}</span>
            </div>}
          <p className="text-gray-600 text-sm line-clamp-2 mb-4" data-id="element-39">
            {project.description}
          </p>
          <div className="flex items-center justify-between text-sm text-gray-500 mb-3" data-id="element-40">
            <div className="flex items-center" data-id="element-41">
              <CalendarIcon className="w-4 h-4 mr-1" data-id="element-42" />
              <span data-id="element-43">{project.startDate}</span>
            </div>
            <span data-id="element-44">to</span>
            <div className="flex items-center" data-id="element-45">
              <CalendarIcon className="w-4 h-4 mr-1" data-id="element-46" />
              <span data-id="element-47">{project.endDate}</span>
            </div>
          </div>
          <div className="mb-1 flex justify-between text-xs" data-id="element-48">
            <span data-id="element-49">Progress</span>
            <span className="font-medium" data-id="element-50">{progressPercentage}%</span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-1.5" data-id="element-51">
            <div className={`h-1.5 rounded-full ${project.status === 'At Risk' ? 'bg-yellow-500' : 'bg-blue-600'}`} style={{
            width: `${progressPercentage}%`
          }} data-id="element-52"></div>
          </div>
        </div>
      </div>
    </Link>;
};
export default ProjectCard;